export default function setupPorts (ports) {
  document.addEventListener('click', (e) => {
    if (typeof e.target.closest !== 'function') return

    if (e.target.closest('.chip-dropdown')) {
      return
    }
    ports.clickOutsideChipDropdown.send(true)
  })
}
